import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { PageHeaderComponent } from '@shared/layout';

@Component({
  selector: 'app-cp-page-header',
  imports: [PageHeaderComponent, MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-page-header title="Some title" [showBreadCrumb]="false" />
    <app-page-header title="Some title with breadcrumb" />
    <app-page-header [title]="header" [showBreadCrumb]="false">
      <ng-template #header>
        <div class="flex align-baseline justify-between text-secondary-50">
          <h1>This is custom title with some button</h1>
          <button mat-button color="primary">Click Me</button>
        </div>
      </ng-template>
    </app-page-header>
    <app-page-header [title]="header">
      <ng-template #header>
        <div class="flex align-baseline justify-between text-secondary-50">
          <h1>This is custom title with some button</h1>
          <button mat-button color="primary">Click Me</button>
        </div>
      </ng-template>
    </app-page-header>
  `,
  styles: ``,
})
export class CpPageHeaderComponent {}
